var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * ルートカード以外の既存カードは含まない。そのためanswersとorderedAnswersの数は一致しない事がある。
 * 会話の選択肢に既存カードが選択された場合は画面遷移した先でそのカードがルートカードとして
 * orderedAnswersに含まれてくる。
 */
export function generateOrderedAnswersExcludeAnotherCards(keyAssignmentAnswers, answerIds) {
    var orderedAnswerIds = generateOrderedAnswerIds(keyAssignmentAnswers, answerIds);
    return orderedAnswerIds.reduce(function (acc, answerId) {
        if (keyAssignmentAnswers[answerId]) {
            acc.push(keyAssignmentAnswers[answerId]);
        }
        return acc;
    }, []);
}
export function generateOrderedAnswerIds(keyAssignmentAnswers, answerIds, parentFoundAllAnswerIds) {
    var _a, _b, _c;
    if (parentFoundAllAnswerIds === void 0) { parentFoundAllAnswerIds = []; }
    var result = [];
    for (var _i = 0, answerIds_1 = answerIds; _i < answerIds_1.length; _i++) {
        var answerId = answerIds_1[_i];
        var answer = keyAssignmentAnswers[answerId];
        if (!answer || result.includes(answerId) || parentFoundAllAnswerIds.includes(answerId)) {
            continue;
        }
        result.push(answerId);
        for (var _d = 0, _e = ((_a = answer.actions) === null || _a === void 0 ? void 0 : _a.actions) || []; _d < _e.length; _d++) {
            var action = _e[_d];
            if (!(action === null || action === void 0 ? void 0 : action.id) || !keyAssignmentAnswers[action.id]) {
                continue;
            }
            var a = keyAssignmentAnswers[action.id];
            if (!a || result.includes(a.id) || parentFoundAllAnswerIds.includes(answerId)) {
                continue;
            }
            var mergedParentFoundAllAnswerIds = __spreadArray(__spreadArray([], result, true), parentFoundAllAnswerIds, true);
            var carouselChildResult = generateOrderedAnswerIds(keyAssignmentAnswers, [a.id], mergedParentFoundAllAnswerIds);
            result.push.apply(result, carouselChildResult);
        }
        for (var _f = 0, _g = answer.contents || []; _f < _g.length; _f++) {
            var content = _g[_f];
            for (var _h = 0, _j = ((_b = content.carousel) === null || _b === void 0 ? void 0 : _b.actions) || []; _h < _j.length; _h++) {
                var carouselAction = _j[_h];
                for (var _k = 0, _l = ((_c = carouselAction === null || carouselAction === void 0 ? void 0 : carouselAction.value) === null || _c === void 0 ? void 0 : _c.actions) || []; _k < _l.length; _k++) {
                    var action = _l[_k];
                    if (!(action === null || action === void 0 ? void 0 : action.id) || !keyAssignmentAnswers[action.id]) {
                        continue;
                    }
                    var a = keyAssignmentAnswers[action.id];
                    if (!a || result.includes(a.id) || parentFoundAllAnswerIds.includes(answerId)) {
                        continue;
                    }
                    var mergedParentFoundAllAnswerIds = __spreadArray(__spreadArray([], result, true), parentFoundAllAnswerIds, true);
                    var carouselChildResult = generateOrderedAnswerIds(keyAssignmentAnswers, [a.id], mergedParentFoundAllAnswerIds);
                    result.push.apply(result, carouselChildResult);
                }
            }
        }
    }
    return result;
}
//# sourceMappingURL=sortAnswer.js.map